import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import { Modal, Button, ButtonGroup } from 'ui';
import PublishedVersionCollection from './PublishedVersionCollection';

const LessonVersionModalContainer = props => {
  const { closeModal, isScormLesson } = props;

  return (
    <ModalContainer onEscape={closeModal}>
      <Modal shown className="LessonVersionModal-wrapper bg-gray-lightest">
        <Modal.Content className="d-f fd-c">
          <h1 className="LessonVersionModal-title pb-24 ff-ss fw-n">
            {isScormLesson
              ? t('versions.version_history')
              : t('versions.all_published_versions')}
          </h1>
          {!isScormLesson && (
            <div className="lh-18 fz-14 pb-24 c-brand-gray-darker">
              {t('versions.linked_element_note')}
            </div>
          )}
          <PublishedVersionCollection {...props} />
        </Modal.Content>
        <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
          <Button onClick={closeModal}>Close</Button>
        </ButtonGroup>
      </Modal>
    </ModalContainer>
  );
};

export default LessonVersionModalContainer;
